module.exports = __webpack_public_path__ + "static/media/IMG_0012.3ae1ca77.jpg";